import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from "@angular/core"
import { Router } from "@angular/router"
import { MapService } from "src/app/services/map.service"
import { ITALY_BOUNDS } from "src/configs/map_configuration"

@Component({
	selector: "app-search-place",
	templateUrl: "./search-place.component.html",
	styleUrls: ["./search-place.component.scss"]
})
export class SearchPlaceComponent implements OnInit {
	autocomplete: google.maps.places.Autocomplete
	public address: any
	public geocoder = new google.maps.Geocoder()
	public activeCoordinates = "wgs84"
	public showCoordinatesSwitch = false
	@Output() onSelected: EventEmitter<any> = new EventEmitter()
	@Output() onSelectedCoordinates: EventEmitter<any> = new EventEmitter()
	@Output() onChangeCoordinatesFormat: EventEmitter<any> = new EventEmitter()
	@Output() isCoordinate: EventEmitter<string> = new EventEmitter()
	@ViewChild("searchTextField", { static: true }) searchTextField: any

	constructor(
		public mapService: MapService,
		private router: Router
	) {}

	ngOnInit() {
		const options: google.maps.places.AutocompleteOptions = {
			bounds: ITALY_BOUNDS,
			types: ["address"], // address , regions, cities,
			strictBounds: true,
			componentRestrictions: { country: "it" }
		}
		this.autocomplete = new google.maps.places.Autocomplete(this.searchTextField.nativeElement, options)
		this.autocomplete.addListener("place_changed", () => {
			const p = this.autocomplete.getPlace()
			if (!this.isCoordinates(this.searchTextField.nativeElement.value)) {
				this.showCoordinatesSwitch = false
				const matchPlace = p.formatted_address === this.searchTextField.nativeElement.value
				p.formatted_address = matchPlace ? p.formatted_address : this.searchTextField.nativeElement.value
				this.onSelected.emit(p)
			}
		})
	}

	public checkCoordinates() {
		if (this.isCoordinates(this.address)) {
			this.showCoordinatesSwitch = true
			const latlng = new google.maps.LatLng(this.address.split(",")[0], this.address.split(",")[1])
			if (this.activeCoordinates === "ed50") {
				this.mapService.convertCoordinates(latlng.lat(), latlng.lng()).subscribe(res => {
					if (res) {
						const selectedPoint = this.onSelectCoordinates(res.lat, res.lng)
						this.onSelectedCoordinates.emit(selectedPoint)
					} else {
						this.onSelectedCoordinates.emit(null)
					}
				})
			} else if (this.activeCoordinates === "wgs84") {
				const selectedPoint = this.onSelectCoordinates(latlng.lat(), latlng.lng())
				this.onSelectedCoordinates.emit(selectedPoint)
			}
		}
	}

	private onSelectCoordinates(lat, lng) {
		let point = { formatted_address: null, coordinates: null }
		const position = new google.maps.LatLng({
			lat: lat,
			lng: lng
		})
		point["formatted_address"] = lat + ", " + lng
		point["coordinates"] = position
		return point
	}

	onInputChange(e) {
		this.showCoordinatesSwitch = this.isCoordinates(e) ? true : false
	}

	isCoordinates(coordinates) {
		var args = coordinates.split(/,/)
		var lat = /^(-?[1-8]?\d(?:\.\d{1,18})?|90(?:\.0{1,18})?)$/
		var lon = /^(-?(?:1[0-7]|[1-9])?\d(?:\.\d{1,18})?|180(?:\.0{1,18})?)$/
		const ret = lat.test(args[0].trim()) == true && lon.test(args[1].trim()) == true
		this.isCoordinate.emit(
			ret && this.searchTextField.nativeElement.value
				? "Coordinates"
				: !ret && this.searchTextField.nativeElement.value
					? "Address"
					: null
		)
		return ret
	}

	reset() {
		this.address = null
		this.showCoordinatesSwitch = false
	}

	onChangeToggle(e) {
		this.activeCoordinates = e.checked ? "ed50" : "wgs84"
		this.onChangeCoordinatesFormat.emit({ type: this.activeCoordinates })
	}
}
